import { ActionHandlerParams } from '../../types';
import { execOneClubQuestionMutation } from '../form-action-helpers';

export const oneClubQuestionHandler = async (params: ActionHandlerParams) => {
  return await execOneClubQuestionMutation(params);
};

export default oneClubQuestionHandler;